import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import Spinner from '../Spinner';
import { LoadingContainer, LoadingText, SpinnerContainer } from './Loading.style';
type Props = {
  withSpinner?: boolean;
};
const Loading: FC<Props> = t0 => {
  const $ = _c(5);
  const {
    withSpinner: t1
  } = t0;
  const withSpinner = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoadingText>Loading data</LoadingText>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== withSpinner) {
    t3 = withSpinner && <SpinnerContainer><Spinner size="small" /></SpinnerContainer>;
    $[1] = withSpinner;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <LoadingContainer>{t2}{t3}</LoadingContainer>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default Loading;